export const CLIENT_ID = 'compeon-registration-service'
